import Axios from "axios-observable";

export const FinancialStatementFixApi = {
  financialStatementFixTooltips: ({ report_id }) => Axios.get(
    `/reports/${report_id}/financial_statement_fixes/tooltips`
  ),
};